import './ApprovalProgress.less';
import { useEffect, useState } from "react";
import { useTranslations } from "@components/context/TranslationContext";
import Portrait from "@components/Portrait";
import Label from "@components/core/Label";

const ApprovalProgress = ({ approvalProgress: _approvalProgress }) => {
    const { t } = useTranslations();
    const [approvalProgress, setApprovalProgress] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const {
        steps: approvalProgressSteps = [],
    } = approvalProgress;

    const ApprovalProgressList = () => {
        const ApprovalProgressStep = ({ approvalProgressStep = {} }) => {
            const {
                label,
                order,
                transitions = [],
            } = approvalProgressStep || {};
            const transition = transitions[0] || {};
            const {
                reviewers = [],
                requirement = {},
            } = transition || {};
            const {
                description,
            } = requirement || {};

            const ApprovalProgressStepReviewer = ({ reviewer = {} }) => {
                const {
                    photo_url: photoUrl,
                    name,
                    first_name: firstName,
                    last_name: lastName,
                    title,
                    status,
                    is_removed: isRemoved,
                } = reviewer || {};
                const {
                    label: statusLabel,
                    style: statusStyle,
                } = status || {};

                return (
                    <div className={`ApprovalProgressStepReviewer ${isRemoved ? 'is-removed' : ''}`}>
                        <Portrait
                            userPhoto={photoUrl}
                            userName={name}
                            userFirstName={firstName}
                            userLastName={lastName}
                        />
                        {(name || title) &&
                            <div className="ApprovalProgressStepReviewer-info">
                                {name &&
                                    <div className="ApprovalProgressStepReviewer-name">
                                        <strong>{name}</strong>
                                    </div>
                                }
                                {title && <div className="ApprovalProgressStepReviewer-title">{title}</div>}
                            </div>
                        }
                        {statusLabel &&
                            <div className="ApprovalProgressStepReviewer-status">
                                <Label status={statusStyle}>{statusLabel}</Label>
                            </div>
                        }
                    </div>
                );
            };

            return (
                <div className="ApprovalProgressStep">
                    <div className="ApprovalProgressStep-step">
                        <div className="ApprovalProgressStep-step-number">{order}</div>
                    </div>
                    <div className="ApprovalProgressStep-info">
                        {(description || label) && <div className="ApprovalProgressStep-title">{description || label}</div>}
                        {reviewers.length > 0 &&
                            <div className="ApprovalProgressStep-reviewers">
                                {reviewers.map((reviewer, i) => <ApprovalProgressStepReviewer key={i} reviewer={reviewer} />)}
                            </div>
                        }
                    </div>
                </div>
            );
        };

        return (
            <div className="ApprovalProgressList">
                {approvalProgressSteps.map((approvalProgressStep, i) => <ApprovalProgressStep key={i} approvalProgressStep={approvalProgressStep} />)}
            </div>
        );
    };

    useEffect(() => {
        setApprovalProgress(_approvalProgress);
    }, [_approvalProgress]);

    return (
        <div className="ApprovalProgress">
            {isLoading ? (
                <div className="placeholder-text">{t('Loading...')}</div>
            ) : (
                approvalProgressSteps.length ? (
                    <ApprovalProgressList />
                ) : (
                    <div className="placeholder-text">{t('No approvers found')}</div>
                )
            )}
        </div>
    );
};

export default ApprovalProgress;